import React from 'react';
import {
    Grid,
    TextField,
    Paper,
    Container,
    Typography,
    Button,
    Divider,
    Dialog,
    DialogContent,
    DialogTitle,
} from '@material-ui/core';
import {useHistory, useLocation} from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import CloseIcon from '@mui/icons-material/Close';
import FormHelperText from '@mui/material/FormHelperText';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';

const useStyles = makeStyles({
    alertContent: {
        marginTop: '46px !important',
        backgroundColor: "white !important",
        borderLeft: '5px solid #DB6200',
        boxShadow: '0px 3px 4px rgba(0, 0, 0, 0.07), 0px 3px 3px rgba(0, 0, 0, 0.06), 0px 1px 8px rgba(0, 0, 0, 0.1);'
    },
    subHeader: {
        color: "#6D6D6E ",
        fontSize: "24px ",
        fontWeight: "bold",
        margin: "35px, 0px",
        fontFamily: "Whitney"
    },
    body: {
        color: "#6D6D6E",
        fontSize: "20px ",
        fontFamily: "Whitney ",
        fontStyle: "semiBold"
    },
    tocbody:{
        color: "#6D6D6E",
        fontSize: "16px ",
        fontFamily: "Whitney ",
        fontStyle: "semiBold"
    },
    buttonContainer: {
        boxShadow: "0px 0px 0px 0px",
        width: "272px",
        paddingTop: "42px",
        paddingBottom: "10px"
    },
    paper: {
        boxShadow: "0px 0px 0px 0px !important",
        paddingTop: "46px !important"
    },
    basicInfo: {
        fontFamily: "Whitney !important",
        fontWeight: "bold !important",
        fontSize: "16px !important",
        align: "left",
        verticalAlign: "top"
    },
    textField: {
        paddingTop: "6px !important",
    },
    header: {
        fontSize: "48px", fontWeight: 400, padding: "1em 0 1rem", letterSpacing: "0.5px",
        lineHeight: "55px",
        fontFamily: '"Chronicle Text G1", "Frank Ruhl Libre", serif',
        position: "relative",
        marginBottom: "1em",
    },
    divider: {
        borderBottom: "6px solid #B40F87",
        width: 40
    },
    blue: {
        color: "#89CFF0",
        textDecoration: "underline",
        cursor: "pointer"
    },
    closeButton: {
        float: 'right'
    },
    container: {
        paddingBottom: '60px'
    }
})



const CCDoesNotExist = () => {
  
    
    const classes = useStyles();
    const history = useHistory();
    const claimReq = useLocation();
    const [state, setState] = React.useState('');
    const [open, setOpen] = React.useState(false);
    const handleClose = () => setOpen(false);
    const [zipCode, setZipCode] = React.useState("");
    const [zipCodeError, setZipCodeError] = React.useState(null);
    const [billingAddres1, setBillingAddres1] = React.useState("");
    const [billingAddres1Error, setBillingAddres1Error] = React.useState(null);
    const [billingAddres2, setBillingAddres2] = React.useState("");
    const [city, setCity] = React.useState("");
    const [cityError, setCityError] = React.useState(null);
   

    const data = { billingAddres1: "",  billingAddres2: "", city: "",zipCode:"" , state :""};

    const handleBillingAddres1Change = (e) =>{
        if(!!billingAddres1Error) setBillingAddres1Error(null)
        setBillingAddres1(e.target.value);
    }
    const handleBillingAddres2Change = (e) =>{       
        setBillingAddres2(e.target.value);
    }

    const handleCityChange = (e) =>{
        if(!!cityError) setCityError(null)
        setCity(e.target.value);
    }
    const handleZipCodeChange = (e) =>{
        if(!!zipCodeError) setZipCodeError(null)
        setZipCode(e.target.value);
    }



    const submit = () => {
        data.billingAddres1= billingAddres1.trim();        
        data.city=city.trim();
        data.zipCode=zipCode;
        data.billingAddres2=billingAddres2.trim();
        data.state=state;
        console.log("data",data);
        history.push("/EnterCCDetailsPage/",{ data });
        };
    

    const sendNow = () => {
        if (validate()) {
                submit();
        }
    }


    const validate = () => {
        let valid = true;
        const validZipRegex =  /(^\d{5}$)|(^\d{5}-\d{4}$)/;
       // const nameRegex = /[A-Za-z]/;
       const nameRegex = /^[a-zA-Z'\s\-]+(\s*[a-zA-Z])*$/;
        if (!billingAddres1 || billingAddres1.trim() === "") {
            valid = false;
            setBillingAddres1Error("Please enter a valid Billing Address");
        }
        if (!city || city.trim() === "" || !nameRegex.test(city.trim())) {
            valid = false;
            setCityError("Please enter a valid City");
        }
      
        if (!zipCode || zipCode.trim() === "" || !validZipRegex.test(zipCode.trim())) {
            valid = false;
            setZipCodeError("Please enter a valid zip code");
        }
        if (state=="" ) {
            valid = false;
            setState("Select");
        }
        // debugger;
        if (valid) return valid;
    }
    const TermsAndConditions = () => (
        <Dialog
            open={open}
            onClose={handleClose}
            scroll='paper'
        >
            <DialogTitle>
                Terms and Conditions
                <Button className={classes.closeButton} onClick={handleClose}>
                    <CloseIcon />
                </Button>1
            </DialogTitle>
            <DialogContent dividers={true} className={classes.tocbody}>
                <p>Our third party service providers will need to store your credit card details in order for us to use them for your future purchases or in other transactions with you. All such information will be stored securely, and all such payments will be remitted in a secure manner, in accordance with all applicable laws and industry standards. In order to allow us to store such information we will need you to consent to the Stored Credential Consent Agreement below and print out a copy of the agreement for your records.</p>
                <p>Consent: You acknowledge that Ascension Pharmacy Services or its third party service providers will need to store your credit card information, including but not limited to credit card number, expiration date and associated contact information, in order to process future transactions and you are hereby providing consent for that storage.</p>
                <p>Future transactions: Future transactions include charges related to customer initiated refills and prescriptions that customer has chosen to refill automatically. </p>
                <p>Amount Charged: If you have a co-pay or coinsurance, we will charge the default payment option on file when your order is shipped. Copayment, co-pay or coinsurance is the amount a plan member is required to pay for a prescription in accordance with a plan. The amount may be a deductible, a percentage of the prescription price, a fixed amount or other charge, with a balance, if any, paid by a plan.</p>
                <p>Notification: I understand that Ascension Pharmacy Services will notify me via the email address associated with my account or via text message in the event of any changes to this Consent Agreement and that the Consent Agreement will otherwise remain in full force and effect until I/we have informed Ascension of my/our desire to terminate this Consent Agreement or if my/our account has been deactivated.</p>
                <p>Use of the Stored Credential: Your stored credit card number will be used only to process future payments per the Cardholder Specific Terms above. The use of other information that may be contained within the stored credential such as your name and email address will only be used as specified in our Privacy Policy at INSERT LINK [ https://ascension.org/PrivacyPolicy ]</p>
                <p>Cancellation Policies: You may cancel consent or change payment methods at any time by contacting Ascension Pharmacy Services at 833-Meds-ARx.</p>
                <p>Refunds: If you believe a charge has been made in error or your prescription doesn’t arrive, contact us immediately at (833) Meds-ARx or by mail at ascensionrx@ascension.org</p>
                <p>Please be sure to print the Agreement and by clicking accept during the add payment flow it constitutes your acknowledgement and acceptance of the Stored Card Agreement.</p>
            </DialogContent>
        </Dialog>
    )


   
    return (
        <Container className={classes.container}>
            <TermsAndConditions/>
            <Typography className={classes.header}>
                Ascension Rx Payment Details 
                <Divider className={classes.divider} />
            </Typography>
            <Typography className={classes.subHeader}>Hello {claimReq.state.firstName},</Typography>
           <Typography className={classes.subHeader}> Please enter the billing address details</Typography>

            <Paper className={classes.paper}>
            

                <Grid item container direction="column" spacing={2}>
                    <Grid item container direction="column">
                        <Typography className={classes.basicInfo}>Billing Address </Typography>
                    </Grid>
                    <Grid item container direction="row" spacing={4}>
                        <Grid item xs={8} container direction="column" spacing={2} className={classes.textField}>
                            <Grid item>
                                <TextField
                         inputProps={{maxLength :30}}
                         error={!!billingAddres1Error}
                         required
                                    style={{
                                        backgroundColor: "white",
                                        width: "299px",
                                        height: "48px",
                                        marginBottom: "22px"
                                    }}
                                    variant="outlined"
                                    type="text"
                                    value={billingAddres1}
                                    helperText={!!billingAddres1Error && billingAddres1Error}
                                    onChange={handleBillingAddres1Change}
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                    
             </Grid>

             <Grid item container direction="column" spacing={2}>
                    <Grid item container direction="column">
                        <Typography className={classes.basicInfo}></Typography>
                    </Grid>
                    <Grid item container direction="row" spacing={4}>
                        <Grid item xs={8} container direction="column" spacing={2} className={classes.textField}>
                            <Grid item>
                                <TextField
                                inputProps={{maxLength :30}}

                                    style={{
                                        backgroundColor: "white",
                                        width: "299px",
                                        height: "48px",
                                        marginBottom: "22px"
                                    }}
                                    variant="outlined"
                                    type="text"
                                    value={billingAddres2}                                  
                                    onChange={handleBillingAddres2Change}
                                
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                    
             </Grid>
             <Grid item container direction="column" spacing={2}>
                    <Grid item container direction="column">
                        <Typography className={classes.basicInfo}>City</Typography>
                    </Grid>
                    <Grid item container direction="row" spacing={4}>
                        <Grid item xs={8} container direction="column" spacing={2} className={classes.textField}>
                            <Grid item>
                                <TextField
                                    inputProps={{maxLength :100}}
                                    error={!!cityError}
                                     required
                                    style={{
                                        backgroundColor: "white",
                                        width: "299px",
                                        height: "48px",
                                        marginBottom: "22px"
                                    }}
                                    variant="outlined"
                                    type="text"
                                    value={city}
                                    helperText={!!cityError && cityError}
                                    onChange={handleCityChange}
                                />
                            </Grid>
                        </Grid>
                    </Grid>
             </Grid>
           
             <Grid item container direction="column" spacing={2}>
                    <Grid item container direction="column">
                        <Typography className={classes.basicInfo}>State</Typography>
                    </Grid>
             <FormControl fullWidth  sx={{ m: 1, width: 300, marginBottom: "22px" }} >
           
        <InputLabel id="demo-simple-select-label"  > State</InputLabel>
        <Select
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          value={state}        
          required
           label= "Select"        
            
        
          
          onChange={(event) => setState(event.target.value)}
        >
           <MenuItem value="Select">Select</MenuItem>
          <MenuItem value="AL">Alabama</MenuItem>
          <MenuItem value="AK">Alaska</MenuItem>
          <MenuItem value="AZ">Arizona</MenuItem>
          <MenuItem value="AR">Arkansas</MenuItem>
          <MenuItem value="CA">California</MenuItem>
          <MenuItem value="CO">Colorado</MenuItem>
          <MenuItem value="CT">Connecticut</MenuItem>
          <MenuItem value="DE">Delaware</MenuItem>
          <MenuItem value="DC">District of Columbia</MenuItem>
          <MenuItem value="FL">Florida</MenuItem>
          <MenuItem value="GA">Georgia</MenuItem>
          <MenuItem value="HI">Hawaii</MenuItem>
          <MenuItem value="ID">Idaho</MenuItem>
          <MenuItem value="IL">Illinois</MenuItem>
          <MenuItem value="IN">Indiana</MenuItem>
          <MenuItem value="IA">Iowa</MenuItem>
          <MenuItem value="KS">Kansas</MenuItem>
          <MenuItem value="KY">Kentucky</MenuItem>
          <MenuItem value="LA">Louisiana</MenuItem>
          <MenuItem value="ME">Maine</MenuItem>
          <MenuItem value="MD">Maryland</MenuItem>
          <MenuItem value="MA">Massachusetts</MenuItem>
          <MenuItem value="MI">Michigan</MenuItem>
          <MenuItem value="MN">Minnesota</MenuItem>
          <MenuItem value="MS">Mississippi</MenuItem>
          <MenuItem value="MO">Missouri</MenuItem>
          <MenuItem value="MT">Montana</MenuItem>
          <MenuItem value="NE">Nebraska</MenuItem>
          <MenuItem value="NV">Nevada</MenuItem>
          <MenuItem value="NH">New Hampshire</MenuItem>
          <MenuItem value="NJ">New Jersey</MenuItem>
          <MenuItem value="NM">New Mexico</MenuItem>
          <MenuItem value="NY">New York</MenuItem>
          <MenuItem value="NC">North Carolina</MenuItem>
          <MenuItem value="ND">North Dakota</MenuItem>
          <MenuItem value="OH">Ohio</MenuItem>
          <MenuItem value="OK">Oklahoma</MenuItem>
          <MenuItem value="OR">Oregon</MenuItem>
          <MenuItem value="PA">Pennsylvania</MenuItem>
          <MenuItem value="RI">Rhode Island</MenuItem>
          <MenuItem value="SC">South Carolina</MenuItem>
          <MenuItem value="SD">South Dakota</MenuItem>
          <MenuItem value="TN">Tennessee</MenuItem>
          <MenuItem value="TX">Texas</MenuItem>
          <MenuItem value="UT">Utah</MenuItem>
          <MenuItem value="VT">Vermont</MenuItem>
          <MenuItem value="VA">Virginia</MenuItem>
          <MenuItem value="WA">Washington</MenuItem>
          <MenuItem value="WV">West Virginia</MenuItem>
          <MenuItem value="WI">Wisconsin</MenuItem>
          <MenuItem value="WY">Wyoming</MenuItem>
          
          

        </Select>
        {
            (state=="Select")?<FormHelperText error sx={{ m: 1, width: 300, marginBottom: "14px" }}>Please select State </FormHelperText>:<></>
        }
        
      </FormControl>
             </Grid>

             <Grid item container direction="column" spacing={2}>
                    <Grid item container direction="column">
                        <Typography className={classes.basicInfo}>Zip Code</Typography>
                    </Grid>
                    <Grid item container direction="row" spacing={4}>
                        <Grid item xs={8} container direction="column" spacing={2} className={classes.textField}>
                            <Grid item>
                                <TextField
                                                inputProps={{maxLength :6}}
                                                error={!!zipCodeError}
                                                required
                                    style={{
                                        backgroundColor: "white",
                                        width: "299px",
                                        height: "48px",
                                        marginBottom: "42px"
                                    }}
                                    variant="outlined"
                                    value={zipCode}
                                    type="text"
                                    helperText={!!zipCodeError && zipCodeError}
                                    onChange={handleZipCodeChange}
                                
                                />
                            </Grid>
                        </Grid>
                    </Grid>
             </Grid>
        </Paper>
            <Typography className={classes.body}>Select “Add Payment Info” to enter or change your payment details and make your next fill easy and hassle-free.</Typography>
            <Typography className={classes.body}>By selecting “Add Payment Info”, you are agreeing to the <span className={classes.blue} onClick={()=>setOpen(true)}>Terms & Conditions</span>
            </Typography>

            <Paper className={classes.buttonContainer}>
                <Button variant="contained" size="large"
                    color="primary"
                    onClick={sendNow}>ADD PAYMENT INFO</Button>
            </Paper>

        </Container>
    )
}

export default CCDoesNotExist